define('views/pages/SocialWallPageView',['underscore','jquery','PageView','router', 'app', 'masonry'
],function(_,$,PageView,router, app, Masonry){

    return PageView.extend({
        pageName:'SocialWall',
        el: '.social-wall',
        events: {

        },

        initialize:function(){

            var view = this;
            // PageView constructor heritage
            PageView.prototype.initialize.apply(view,arguments);
            //
            if (app.isDesktop()){
                new Masonry('.msr-grid', {
                    // options
                    itemSelector: '.msr-item',
                    columnWidth: 250,
                    gutter: 30,
                    fitWidth: true
                });
            }
        }





    });

});
